<div class="ui-g container" *ngIf="roulette" provide-parent-form>
    <app-upload-image [(imageUrl)]="logo" (imageUrlChange)="onChooseLogo($event)" (deleteEvent)="onDeleteLogo()" ></app-upload-image>

    <!-- shape -->
        <div class="r-form-group">
            <div class="r-form-group">
                <label class="title" for="shape">{{'LOGOֹֹּׁ_SETTING.SHAPE'|translate}}</label>
                <p-dropdown [appendTo]="null" [options]="shapeOptions" inputId="shape" name="shape"
                    [(ngModel)]="logoSettings.LogoShape">
                    <ng-template pTemplate="selectedItem">
                        {{logoSettings.LogoShape|enumTranslate:logoShape}}
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                        {{item|enumTranslate:logoShape}}
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <!-- size -->
        <div class="r-form-group">
            <label class="title" for="size">{{'LOGOֹֹּׁ_SETTING.SIZE'|translate}}</label>
            <p-dropdown [appendTo]="null" [options]="sizeOptions" name="size" [(ngModel)]="logoSettings.LogoSize">
                <ng-template pTemplate="selectedItem">
                    {{logoSettings.LogoSize|enumTranslate:logoSize}}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{item|enumTranslate:logoSize}}
                </ng-template>
            </p-dropdown>
        </div>

        <!-- location -->
        <div class="r-form-group">
            <label class="title" for="location">{{'LOGOֹֹּׁ_SETTING.LOCATION'|translate}}</label>
            <p-dropdown [appendTo]="null" [options]="locationOptions" name="location"
                [(ngModel)]="logoSettings.Location">
                <ng-template pTemplate="selectedItem">
                    {{logoSettings.Location|enumTranslate:logoLocation}}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{item|enumTranslate:logoLocation}}
                </ng-template>
            </p-dropdown>
        </div>

        <!-- rotation -->
        <div class="r-form-group">
            <label class="title" for="rotation">{{'LOGOֹֹּׁ_SETTING.ROTATION'|translate}}</label>
            <p-dropdown [appendTo]="null" [options]="rotationOptions" name="rotation"
                [(ngModel)]="logoSettings.LogoRotation" [placeholder]="'ENUMS.LogoRotation.none'|translate">
                <ng-template pTemplate="selectedItem">
                    {{logoSettings.LogoRotation|enumTranslate:logoRotation}}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{item|enumTranslate:logoRotation}}
                </ng-template>
            </p-dropdown>
        </div>

        <!-- frame -->
        <div class="r-form-group">
            <label class="title">{{'LOGOֹֹּׁ_SETTING.FRAME'|translate}}</label>
            <button class="frame-btn full-width" id="button_frame" (click)="op.toggle($event)"
                [style.background-color]="logoSettings.BorderColor?logoSettings.BorderColor:'transparent'">
                <span>{{ logoSettings.BorderColor || ('LOGOֹֹּׁ_SETTING.NO_FRAME' | translate) }}</span>
            </button>

        </div>

    <p-overlayPanel styleClass="overlayPanelColors" #op appendTo="body">
        <ng-template pTemplate>
            <p-colorPicker [(ngModel)]="logoSettings.BorderColor" name="borderColor" [inline]="true">
            </p-colorPicker>
            <button class="empty command-button full" type="button"
                (click)="logoSettings.BorderColor = null">{{'LOGOֹֹּׁ_SETTING.NO_FRAME'|translate}}</button>
        </ng-template>
    </p-overlayPanel>
</div>